const auth = '/auth';

export const authLogin = () => {
  return `${auth}/login`;
};

export const authCustomLogin = (email: string) => {
  return `${auth}/custom-login?email=${email}`;
};
